const MAX_URL = 2048;

/**
 * Allow only http(s) destinations. Rejects executable / script / file schemes.
 * Shared contract for web, Electron, and a future browser extension.
 */
export function isSafeHttpUrl(value) {
  if (typeof value !== 'string') return false;
  const raw = value.trim();
  if (!raw || raw.length > MAX_URL) return false;
  if (/\s/.test(raw)) return false;
  let parsed;
  try {
    parsed = new URL(raw);
  } catch {
    return false;
  }
  if (parsed.username || parsed.password) return false;
  return parsed.protocol === 'http:' || parsed.protocol === 'https:';
}

export function normalizeShortcutUrl(value) {
  const raw = typeof value === 'string' ? value.trim() : '';
  return isSafeHttpUrl(raw) ? raw : null;
}
